import { z } from 'zod';

// Kotlin's integer types, source: https://kotlinlang.org/docs/numbers.html#integer-types

export const INTEGER_BOUNDARIES = {
    LONG: {
        // biome-ignore lint/correctness/noPrecisionLoss: TODO
        MIN: -9223372036854775808,
        // biome-ignore lint/correctness/noPrecisionLoss: TODO
        MAX: 9223372036854775807,
    },
    INT: {
        MIN: -2147483648,
        MAX: 2147483647,
    },
    SHORT: {
        MIN: -32768,
        MAX: 32767,
    },
    BYTE: {
        MIN: -128,
        MAX: 127,
    },
} as const;

export const LongSchema = z
    .number()
    .int()
    .min(INTEGER_BOUNDARIES.LONG.MIN)
    .max(INTEGER_BOUNDARIES.LONG.MAX);

export const IntSchema = z
    .number()
    .int()
    .min(INTEGER_BOUNDARIES.INT.MIN)
    .max(INTEGER_BOUNDARIES.INT.MAX);

export const ShortSchema = z
    .number()
    .int()
    .min(INTEGER_BOUNDARIES.SHORT.MIN)
    .max(INTEGER_BOUNDARIES.SHORT.MAX);

export const ByteSchema = z
    .number()
    .int()
    .min(INTEGER_BOUNDARIES.BYTE.MIN)
    .max(INTEGER_BOUNDARIES.BYTE.MAX);
